import { render, staticRenderFns } from "./downloadReceipt.vue?vue&type=template&id=5ea66a54&scoped=true"
import script from "./downloadReceipt.vue?vue&type=script&lang=ts"
export * from "./downloadReceipt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea66a54",
  null
  
)

export default component.exports